'use client'
import { ProductPrice } from '@/eshop/gql/graphql'
import { useCallback, useContext, useMemo, useState } from 'react'
import { BasketContext } from '../BasketProvider'

interface Props {
    // priceId: ProductPrice['id']
    catNo: string
}

export default function BasketPlusMinus({ catNo }: Props) {
    const { products, changeCount } = useContext(BasketContext)

    const currentProductCount = useMemo(
        () => products.find((p) => p.catNo === catNo)?.count || 0,
        [products, catNo]
    )

    const [isControlled, setIsControlled] = useState(true)

    const handleChangeCount = useCallback(
        (by: number) => () => {
            changeCount(catNo, by)
        },
        [changeCount, catNo]
    )

    return (
        <div className="flex items-center justify-between border rounded bg-white w-24 p-2 shrink-0">
            <button
                className="w-5 h-5 shrink-0"
                onClick={handleChangeCount(-1)}
            >
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M4.1665 10H15.8332"
                        stroke="#13253B"
                        strokeWidth="1.5"
                        strokeLinecap="square"
                        strokeLinejoin="round"
                    />
                </svg>
            </button>
            <input
                type="text"
                maxLength={3}
                size={3}
                value={isControlled ? currentProductCount : undefined}
                onChange={isControlled ? () => {} : undefined}
                className="text-center w-10"
                onFocus={() => setIsControlled(false)}
                onBlur={(e) => {
                    const val = Number(e.target.value)
                    if (val && !Number.isNaN(val)) {
                        const diffCount = val - currentProductCount
                        changeCount(catNo, diffCount)
                    }

                    setIsControlled(true)
                }}
            />
            <button className="w-5 h-5 shrink-0" onClick={handleChangeCount(1)}>
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M10 4.16699V15.8337"
                        stroke="#13253B"
                        strokeWidth="1.5"
                        strokeLinecap="square"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M4.16675 10H15.8334"
                        stroke="#13253B"
                        strokeWidth="1.5"
                        strokeLinecap="square"
                        strokeLinejoin="round"
                    />
                </svg>
            </button>
        </div>
    )
}
